import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import utility, { handleTypeNumberControl } from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import UserContext from "src/provider/state-manager/userProvider"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppText, Button, CustomContainer, FlexRow, Form, FormGroup, ScreenTitle } from "src/style"
import { AccountDeletionContainer, AcctDeletionTerms, AcctDeletionTermsD3, AcctDeletionTermsD2 } from "src/component"
import { Design } from 'src/model'

const AccountDetails = () => {
    const navigate = useNavigate()
    const {notifier} = useContext(VisibilityContext)
    const {info: {institutionData}} = useContext(AppInfoContext) 
    const {setUserProperty} = useContext(UserContext)
    const [input, setInput] = useState({username: '', accountNumber: ''})
    const [showTerms, setShowTerms] = useState(false)

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        setInput({...input, [e.target.name]: e.target.value})
    }
    
    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (input.accountNumber.length != 10) return notifier.show('Kindly provide a valid account number')
        setShowTerms(true)
    }

    async function handleConditionAcceptance() {
        const acctDeletionflowType = utility.getAccountDeletionFlowType()
        await setUserProperty('acctDeletionData', {...input})
        navigate(acctDeletionflowType === 'alias' ? `/${institutionData.alias}/account-deletion/reason` : '/account-deletion/reason')
    }
    
    return (
        <>
            <AccountDeletionContainer>
                <CustomContainer>
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Account Details</ScreenTitle>
                    <AppText topMargin="2" bottomMargin="1.5">Please input Account information to proceed with the delete process</AppText>
                    <Form onSubmit={handleProceed} topMargin='2'>
                    <FormGroup>
                            <label>Account Number</label>
                            <input 
                                name='accountNumber'
                                type='numbe'
                                placeholder="Enter Account Number"
                                value={input.accountNumber}
                                onChange={handleInput}
                                onKeyDown={handleTypeNumberControl}
                                onKeyUp={handleTypeNumberControl}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Username</label>
                            <input 
                                name='username'
                                placeholder="Enter Username"
                                value={input.username}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                            <Button 
                                width='8.7' height='4' 
                                borderColor='#0D968F' hoverBgColor='#ffffff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </AccountDeletionContainer>
            { showTerms &&
                (
                    institutionData.design === Design.DESIGN_1 ?
                        <AcctDeletionTerms
                            close={() => setShowTerms(false)} 
                            next={handleConditionAcceptance}
                        />
                        : institutionData.design === Design.DESIGN_2 ?
                        <AcctDeletionTermsD2
                            close={() => setShowTerms(false)} 
                            next={handleConditionAcceptance}
                        />
                            :
                                <AcctDeletionTermsD3
                                    close={() => setShowTerms(false)} 
                                    next={handleConditionAcceptance}
                                />

                )
            }
        </>
    )
}

export default utility.routeData('account-details', 'Account Details', <AccountDetails/>)